import { action, reaction } from "mobx";
import { landingPageReportApi } from "./api";

const landingPageReportActions = {
  reaction: (expression, effect) => reaction(expression, effect),
  landingPageCompletionMetrics: [],
  filteredLandingPageCompletionMetrics: [],
  filterModel: {},
  landingPageResponseData: null,
  isResponseModalOpen: false,

  getLandingPageCompletionMetrics: action(async function() {
    try {
      this.setIsLoading(true);
      this.setHasError(false);
      this.setErrorMessage("");

      const response = await landingPageReportApi.getLandingPageCompletionMetrics();
      if (response.success) {
        const data = response.data.result || [];
        this.landingPageCompletionMetrics = data;
        this.filteredLandingPageCompletionMetrics = data;
        return data;
      } else {
        this.setHasError(true);
        this.setErrorMessage(response.data.message);
        this.landingPageCompletionMetrics = [];
        this.filteredLandingPageCompletionMetrics = [];
        return [];
      }
    } catch (error) {
      this.setHasError(true);
      this.setErrorMessage(
        error.message || "Failed to fetch landing page completion metrics"
      );
      this.landingPageCompletionMetrics = [];
      this.filteredLandingPageCompletionMetrics = [];
      return [];
    } finally {
      this.setIsLoading(false);
    }
  }),

  resetFilters: action(function() {
    // Reset filter model
    this.filterModel = {};

    // Create a new array with all original data
    const newData = this.landingPageCompletionMetrics.map(item => ({ ...item }));
    this.filteredLandingPageCompletionMetrics = newData;
  }),

  applyFilters: action(function() {
    const metrics = this.landingPageCompletionMetrics;
    const filterModel = this.filterModel;

    let filtered = [...metrics];

    if (filterModel.state) {
      const statusValues = filterModel.state.values;
      filtered = filtered.filter(item =>
        statusValues.includes(item.state.toLowerCase())
      );
    }

    if (filterModel.category) {
      const categoryValues = filterModel.category.values;
      filtered = filtered.filter(item => {
        try {
          const categories = JSON.parse(item.category);
          return categories.some(cat => categoryValues.includes(cat));
        } catch {
          return false;
        }
      });
    }

    if (filterModel.createdDate) {
      const { dateFrom, type } = filterModel.createdDate;
      const filterDate = new Date(dateFrom);
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.createdDate);
        switch (type) {
          case "lessThan":
            return itemDate < filterDate;
          case "equals":
            return itemDate.toDateString() === filterDate.toDateString();
          case "greaterThan":
            return itemDate > filterDate;
          default:
            return true;
        }
      });
    }

    this.filteredLandingPageCompletionMetrics = filtered;
  }),

  getLandingPageTotalCompletion: action(async function(landingPageId) {
    try {
      const response = await landingPageReportApi.getLandingPageTotalCompletion(landingPageId);
      if (response.success) {
        this.landingPageTotalCompletion = response.data.result;
        return response.data.result;
      } else {
        console.error(
          "Error fetching landing page total completion:",
          response.data.message
        );
        return null;
      }
    } catch (error) {
      console.error("Error fetching landing page total completion:", error);
      return null;
    }
  }),

  getLandingPageCompletionDetail: action(async function(landingPageId) {
    try {
      const response = await landingPageReportApi.getLandingPageCompletionDetail(landingPageId);
      if (response.success) {
        return response.data.result;
      } else {
        console.error("Error fetching landing page completion detail:", response.data.message);
        return null;
      }
    } catch (error) {
      console.error("Error fetching landing page completion detail:", error);
      return null;
    }
  }),

  getLandingPageCompletionResponses: action(async function(id) {
    try {
      const response = await landingPageReportApi.getLandingPageCompletionResponses(id);
      if (response.success) {
        this.landingPageResponseData = response.data.result;
        this.isResponseModalOpen = true;
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Error fetching landing page completion responses:", error);
      return null;
    }
  }),

  openResponseModal: action(function(data) {
    this.landingPageResponseData = data;
    this.isResponseModalOpen = true;
  }),

  closeResponseModal: action(function() {
    this.isResponseModalOpen = false;
    this.landingPageResponseData = null;
  })
};

export default landingPageReportActions;